import { cloneDeep } from 'lodash/fp'

/**
 * Retrieves the notifications state.
 * @method getNotificationsInfo
 * @param  {String} [channel] - Specific notification channel information to retrieve.
 * @return {Object}
 */
export function getNotificationsInfo (state, channel = undefined) {
  if (channel) {
    return state.notifications[channel]
  } else {
    return state.notifications
  }
}

/**
 * Retrieves notification config.
 * @method getNotificationConfig
 * @return {Object}
 */
export function getNotificationConfig (state) {
  return cloneDeep(state.config.notifications)
}
